<div class="card border-0 shadow rounded-3 animate__animated animate__fadeIn">
    <div class="card-body p-4">
        <div class="text-center mb-4">
            <a href="#" [routerLink]="['/']">
                <ng-container *ngIf="logo$ | async as logo; else logoSkeleton">
                    <ng-container *ngIf="loadingCompany == false else logoSkeleton">
                        <a *ngIf="companyId != '6a513fd7-cc7e-48d2-9cd0-4f51abb57854' && companyId !='c51c9b70-b692-42cb-9821-0945f72f8a2e' "
                            class="d-flex align-items-center m-auto justify-content-center w-100" routerLink="/">
                            <img [src]="logo" width="180">
                        </a>
                        <a *ngIf="companyId == 'c51c9b70-b692-42cb-9821-0945f72f8a2e'"
                            class="d-flex align-items-center m-auto justify-content-center w-100" routerLink="/">
                            <img width="180" src="../../../../assets/images/meubilhete.png" />
                        </a>
                        <a *ngIf="companyId == '6a513fd7-cc7e-48d2-9cd0-4f51abb57854'"
                            class="d-flex align-items-center m-auto justify-content-center w-100" routerLink="/">
                            <img width="180" src="../../../../assets/images/chamatickets.png" />
                        </a>
                    </ng-container>
                    <ng-template #logoSkeleton>
                        <ngx-skeleton-loader [theme]="{ 
                                width: '100%', 
                                height: '100%'
                            }"></ngx-skeleton-loader>
                    </ng-template>
                </ng-container>
                <ng-template #logoSkeleton>
                    <ngx-skeleton-loader [theme]="{ 
                            width: '180px', 
                            height: '26px'
                        }"></ngx-skeleton-loader>
                </ng-template>
            </a>
        </div>
        <form *ngIf="shouldCheckCpf" [formGroup]="checkCpfForm" (ngSubmit)="checkCpf()">
            <div class="form-floating mb-3">
                <input type="tel" formControlName="cpf" required="true" mask="000.000.000-00" class="form-control"
                    id="cpf" placeholder="CPF">
                <label for="floatingInput">CPF</label>
            </div>
            <div (click)="validateCheckCpf()">
                <button type="submit" class="btn btn-primary" [disabled]="loading || checkCpfForm.controls['cpf'].errors != null">
                    <div *ngIf="loading else displayLoginText">
                        <app-spinner spinnerType="grow" spinnerWidth="21"></app-spinner>
                    </div>
                    <ng-template #displayLoginText>
                        Verificar
                    </ng-template>
                </button>
            </div>
        </form>
        <form *ngIf="!shouldCheckCpf" [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="form-floating mb-3">
                <input *ngIf="producerLogin == false" type="email" class="form-control" id="floatingInput"
                    formControlName="email" placeholder="name@example.com">
                <input *ngIf="producerLogin == true" type="email" class="form-control" id="floatingInput"
                    formControlName="username" placeholder="Usuário ou senha">

                <label for="floatingInput" *ngIf="producerLogin == true">Email ou usuário</label>
                <label for="floatingInput" *ngIf="producerLogin == false">Email</label>
            </div>
            <!-- Mensagens de erro email -->
            <div *ngIf="loginForm.controls['email']?.errors && submitted == true">
                <div *ngIf="loginForm.controls['email']?.errors?.['required'] == true">
                    <p *ngIf="producerLogin == false" class="error">Email é obrigatório</p>
                </div>
                <div *ngIf="loginForm.controls['email']?.errors?.['email'] == true">
                    <p class="error">O email tem que ser um email válido</p>
                </div>
            </div>

            <!-- Mensagens de erro usuário -->
            <div *ngIf="loginForm.controls['username']?.errors && submitted == true">
                <div *ngIf="loginForm.controls['username']?.errors?.['required'] == true">
                    <p *ngIf="producerLogin == true" class="error">Email ou usuário é obrigatório</p>
                </div>
            </div>

            <div class="form-floating mb-3 position-relative">
                <input type="password" class="form-control" id="floatingPassword" formControlName="password"
                    placeholder="Password">
                    <b (click)="showHidePassword()" *ngIf="showPassword == false" style="top: 23px; color: gray; cursor:pointer; right: 10px" class="fa fa-eye position-absolute"></b>
                    <b (click)="showHidePassword()" *ngIf="showPassword == true" style="top: 23px; color: gray; cursor:pointer; right: 10px" class="fa fa-eye-slash position-absolute"></b>
                <label for="floatingPassword">Senha</label>
            </div>
            <!-- Mensagens de erro senha -->
            <div *ngIf="loginForm.controls['password']?.errors && submitted == true">
                <div *ngIf="loginForm.controls['password']?.errors?.['required'] == true">
                    <p class="error">Senha é obrigatória</p>
                </div>
                <div *ngIf="loginForm.controls['password']?.errors?.['minlength']">
                    <p class="error">Senha tem que ter no mínimo 8 caracteres</p>
                </div>
            </div>

            <div class="form-check mb-3">
                <input class="form-check-input" formControlName="rememberPasswordCheck" type="checkbox" value=""
                    id="rememberPasswordCheck">
                <label class="form-check-label" for="rememberPasswordCheck">
                    Lembra senha
                </label>
            </div>
            <div class="d-grid">
                <button class="btn btn-grad btn-lg text-uppercase fw-bold" type="submit"
                    [disabled]="loading || waitTimer != 0 ">
                    <div *ngIf="loading else displayLoginText">
                        <app-spinner spinnerType="grow" spinnerWidth="21"></app-spinner>
                    </div>
                    <p *ngIf="waitTimer != 0">
                        {{waitTimer}}
                    </p>
                    <ng-template #displayLoginText>
                        Entrar
                    </ng-template>
                </button>

                <div *ngIf="showProducerOption == true" class="form-check form-switch mt-5 d-flex justify-center">
                    <input [checked]="producerLogin" class="form-check-input" (click)="defineLoginProducer()"
                        type="checkbox" role="switch" id="flexSwitchCheckDefault">
                    <label class="form-check-label ms-1" for="flexSwitchCheckDefault">Produtor</label>
                </div>
            </div>
            <hr class="my-4">
            <div class="text-center" *ngIf="producerLogin == false">
                <!-- Caso tenha a query redirect-checkout -->
                <div *ngIf="redirectToCheckoutPage == true else showRegularButton">
                    Não possui uma conta? <a class="ms-1" href="#" [routerLink]="['/auth/register']"
                        [queryParams]="{redirect: 'checkout'}">Criar conta</a>
                </div>
                <ng-template #showRegularButton>
                    Não possui uma conta? <a class="ms-1" href="#" [routerLink]="['/auth/register']"
                        [queryParams]="{redirect: redirectTo}">Criar conta</a>
                </ng-template>
                <p class="m-0">ou</p>
                <a routerLink="/auth/recover">Esqueci minha senha</a>
            </div>
        </form>
    </div>
</div>